<template>
  <div class="login-container">
    <!-- 返回按钮 -->
    <van-icon
      name="arrow-left"
      class="back-icon"
      @click="handleBack"
    />

    <!-- 标题 -->
    <h2 class="login-title">
      12306登录
    </h2>

    <!-- 温馨提示 -->
    <p class="login-tip">
      温馨提示：铁路部规定：网络购票或者开具发票必须登录12306账号或者人脸数据验证。
    </p>

    <!-- 手机号输入框 -->
    <van-field
      v-model="trainAccount"
      label="账号"
      placeholder="请输入手机号码"
      type="text"
      clearable
    />

    <!-- 密码输入框 -->
    <van-field
      v-model="password"
      label="密码"
      placeholder="请输入密码"
      type="password"
      clearable
    />

    <!-- 同意协议复选框 -->
    <van-checkbox v-model="isAgreed" class="agree-checkbox">
      同意
      <span class="agreement-link" @click="showAgreement = true">
        《账户授权协议》
      </span>
    </van-checkbox>

    <!-- 登录按钮 -->
    <van-button
      type="primary"
      block
      :disabled="!isAgreed || !isPasswordValid"
      @click="handleLogin"
    >
      登录12306
    </van-button>

    <!-- 协议弹窗 -->
    <van-popup
      v-model="showAgreement"
      position="bottom"
      closeable
      :style="{ height: '80%' }"
    >
      <div class="agreement-content">
        <h3 class="agreement-title">
          账户授权协议
        </h3>
        <pre class="agreement-text">
          火车票12306购票服务协议
          在使用火车票代订服务之前，请您（即用户）仔细阅读下述协议条款。一旦您点击确认本协议，即表示您已接受了以下所述的条款和条件，同意受本协议约束。如果您不同意接受全部的条款和条件，那么您将无法使用本协议约定的技术服务。
          第一条 服务说明
          1. 1通过本平台预订火车票时，可自由选择自行通过您自有的12306账户和密码登陆12306进行预订，也可选择将您的12306账户和密码授权给本平台进行代订。
          1. 2为了更好地给您提供火车票代订服务，一旦您选择12306购票服务，您同意将您的12306账户和密码授权给本平台，允许本平台使用您的12306账户和密码登陆，并完成火车票预订及其相关退改签等操作。
          1. 3 接受此协议，代表自愿委托使用我的12306乘客进行购票。
          第二条 各方权利和义务
          2. 1 本平台提供的是火车票代订服务，您接受本协议，意味着您同意我们使用您填写的乘客信息进行代订，同时您须遵守12306的购票规定的服务条款（https: //kyfw. 12306.cn/otn/regist/rule) .
          2. 2用户了解并同意，本平台会根据您的授权使用您的12306账户及密码操作代订事宜，为了后续进一步向您提供服务，也会在系统中记录您的前述相关信息。但是对于您的隐私信息及相关交易信息，本平台会严格保护。
          2. 3 本平台可根据国家法律法规变化及维护交易秩序、保护消费者权益需要，不时修改本协议。
          2. 4本协议下的技术服务暂不向用户收取技术服务费，但本平台保留收费的权利。
        </pre>
      </div>
    </van-popup>

    <verificate
      ref="verificate"
      element=".login-container"
      :user-name="trainAccount"
      :password="password"
      :sms-check-msg="smsCheckMsg"
      @success="success"
    />


    <face-detection
      ref="face-detection"
      element=".login-container"
      :user-name="trainAccount"
      :password="password"
      @success="success"
    />
  </div>
</template>

<script>
import {Field, Checkbox, Button, Toast, Icon, Popup, Dialog} from 'vant';
import {mapState} from "vuex";
import verificate from './invoice_verificate12306.vue'
import faceDetection from './invoice_face_detection12306.vue'

export default {
  components: {
    'van-field': Field,
    'van-checkbox': Checkbox,
    'van-button': Button,
    'van-icon': Icon,
    'van-popup': Popup,
    verificate,
    faceDetection
  },
  created() {
    console.log("trSearchIn1fo{}",this.trSearchInfo);
  },
  data() {
    return {
      smsCheckMsg: '',
      trainAccount: "", // 手机号码
      password: "", // 密码
      isAgreed: false, // 是否同意协议
      showAgreement: false, // 是否显示协议弹窗
    };
  },
  computed: {
    // 验证手机号码是否有效
    isPhoneNumberValid() {
      return /^1[3456789]\d{9}$/.test(this.trainAccount);
    },
    // 验证密码是否有效（至少6位）
    isPasswordValid() {
      return this.password.length >= 6;
    },
    ...mapState({
      loginConfig: state => state.app.loginConfig,
      trSearchInfo: state => state.tr.trSearchInfo,
      travelerList: state => state.tr.travelerList
    })
  },
  methods: {
    // 处理登录逻辑
    handleLogin() {
      if (this.isAgreed && this.isPasswordValid) {

        let params = {
          password: this.password,
          userName: this.trainAccount,
          isOpenInvoice: '1',
        }

        this.$api['trQuery/12306Login'](params).then(res => {
          if(res.data == 0) {
            this.$dialog({
              message: '登陆失败！请核实后重新登录！'
            })
          } else if(res.data == 1) {
            this.success()
          } else {
            this.$dialog({
              message: res.errMsg
            })
          }
        }).catch(err => {
          if(err.errCode == '239001' || err.errCode == '239003') {
            this.$toast.clear()

            this.smsCheckMsg = err.tips
            this.$dialog.alert({
              title: '温馨提示',
              message: '根据铁路局规定，你的账号需要先完成短信核验。',
              confirmButtonText: '去核验',
            }).then(async () => {
              this.$refs['verificate'].toggle()
            })

          } else if(err.errCode == '239002') {
            this.$toast.clear()

            this.$refs['face-detection'].toggle()
          }
        })

      } else {
        Toast.fail("请输入有效密码并同意协议");
      }
    },
    // 登录成功
    success() {

      // 这里可以调用登录接口
      Toast.success("登录成功！");

      this.$store.commit('tr/update12306Info', {
        trainAccount: this.trainAccount,
        password: this.password,
        isLoginSucccess: true,
      });

      this.$router.go(-1); // 返回上一页
    },
    // 处理返回逻辑
    handleBack() {
      this.$router.go(-1); // 返回上一页
    }
  },
};
</script>

<style scoped>
.login-container {
  padding: 20px;
  max-width: 400px;
  margin: 0 auto;
  position: relative;
}

.back-icon {
  position: absolute;
  top: 20px;
  left: 20px;
  font-size: 20px;
  color: #333;
  cursor: pointer;
}

.login-title {
  text-align: center;
  font-size: 24px;
  color: #333;
  margin-bottom: 20px;
  margin-top: 40px; /* 给返回按钮留出空间 */
}

.login-tip {
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
}

.agree-checkbox {
  margin: 15px 0;
}

.agreement-link {
  color: #1989fa;
  cursor: pointer;
}

.van-button {
  margin-top: 20px;
}

.agreement-content {
  padding: 20px;
}

.agreement-title {
  text-align: center;
  font-size: 18px;
  margin-bottom: 15px;
}

.agreement-text {
  white-space: pre-wrap;
  font-size: 14px;
  line-height: 1.5;
  color: #333;
}
</style>
